import connexion from './connexion';
import inscription from './inscription';
import franceConnect from './franceConnect';
import connexionMce from './connexionMce';

export default {
	connexion,
	inscription,
	franceConnect,
	connexionMce
};
